/**
 * @file axios 实例与拦截器
 */
import axiosBase, { AxiosError } from 'axios';

const axios = axiosBase.create({
    timeout: 150000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});

if ((import.meta as any).env.MODE === 'development') {
    axios.defaults.baseURL = '';
}

// 请求拦截
axios.interceptors.request.use(
    (config) => {
        return config;
    },
    (err: AxiosError) => {
        return Promise.reject(err);
    }
);

// 响应拦截
axios.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (err: AxiosError) => {
        return Promise.reject(err);
    }
);

export default axios;
